<template>
<div class="searchbar">
  <div class="wrapper">
    <input type="text" class="searchbar--input" v-model="searchTerm" @keypress.enter="search" :placeholder="$t('ui.searchbar.placeholder.' + model)" v-focus>
    <span class='icon searchbar--icon yule-icon-search'></span>
    <span @click="search" class="btn-arrow"><i class="icon yule-icon-arrow-right"></i></span>
  </div>
</div>
</template>
<script>

import _ from 'lodash'

export default {
  data(){
    return{
      searchTerm: '',
      searchResults: [],
      isOpen: false
    }
  },
  props: {
    value: String,
    model: String
  },
  watch:{
    value(){
      this.searchTerm = this.value
    },
  },
  mounted(){
    this.searchTerm = this.value
  },
  methods: {
    search(){
      this.$emit('search', this.searchTerm)
    }
  }
}
</script>
<style lang="scss">
.searchbar{
  margin: 0.5em 0 2em;
  @include respond-to("small-up"){
    margin: 0  0 2em 0;
  }
  .btn-arrow {
    margin-left: 1em;
  }
  .wrapper{
    padding: 0;
    display: flex;
    position: relative;
    margin: 0;
    >*{
      align-self: flex-start;
    }
    @include respond-to("small-up"){
      // padding: 0 1em;
    }
  }
  .results{
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    z-index: 5;
    background: $color-white;
    margin: 0 1em 0 1em;
    display: none;
    background: $background-color;
    &.is-open{
      display: block;
    }
    .result{
      padding: 1em;
    }
  }
}
.searchbar--icon{
  font-size: .9em;
  color: $paper-dark;
  align-self: flex-start;
  margin-right: 20px;
  position: absolute;
  top: 0;
  left: 0;
}
.searchbar--input{
  display: block;
  width: 327px;
  padding: 8px;
  font-size: .9em;
  border: 0;
  border-bottom: 2px solid $paper;
  color: $ink-dark;
  padding-left: 2em;
  transition: all .15s ease-out;
  &:hover{
    outline: none;
    border-bottom: 2px solid $paper-dark;
  }
  &:focus{
    outline: none;
    border-bottom: 2px solid $sensual;
  }
  &:active{
    outline: none;
    border-bottom: 2px solid $sensual
  }
  &::placeholder {
    color: $paper-dark;
    font-weight: 400;
    font-size: 1em;
  }

}
@media(max-width: 575px) {
  .searchbar{
    .btn-arrow {
      margin-left: .5em;
      padding: 0 .5em;
      overflow: hidden;
    }
  }
  .searchbar--input {
    width: 230px;
  }
}
</style>



// WEBPACK FOOTER //
// Searchbar.vue?059a5a16